import React, { useState, useEffect, useCallback } from "react";
import { COMPANY_ROLES } from "./SEC_CompanyRoles";
import {
  fetchCompanyUsers,
  assignCompanyUserRole,
  revokeCompanyUserRole,
  searchUsers
} from "./companyUserInteractionService";
// 🎯 Alias bypasses the underscore naming rules for react/jsx-pascal-case
import CompanyUsersView from "./SEC_CompanyUsersView";

export default function SEC_CompanyUsersController({ companyId, companyName }) {
  const [matrixData, setMatrixData] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);

  const siteKey = process.env.REACT_APP_SITE_KEY;

  const loadCompanyUsers = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    try {
      const data = await fetchCompanyUsers(companyId, { siteKey });
      setMatrixData(data || []);
    } finally {
      setLoading(false);
    }
  }, [companyId, siteKey]);

  useEffect(() => {
    loadCompanyUsers();
  }, [loadCompanyUsers]);

  const handleSearch = async (term) => {
    setSearching(true);
    try {
      const results = await searchUsers(term, { siteKey });
      setSearchResults(results || []);
    } finally {
      setSearching(false);
    }
  };

  const handleAssign = async (siteUserGuid, roleCode) => {
    try {
      await assignCompanyUserRole(companyId, siteUserGuid, roleCode, { siteKey });
      setSearchResults([]);
      loadCompanyUsers();
    } catch (err) {
      alert(err.message || "Company user assignment failed.");
    }
  };

  const handleRevoke = async (siteUserGuid, roleCode) => {
    try {
      await revokeCompanyUserRole(companyId, siteUserGuid, roleCode, { siteKey });
      loadCompanyUsers();
    } catch (err) {
      alert(err.message || "Company user revoke failed.");
    }
  };

  return (
    <CompanyUsersView
      companyName={companyName}
      data={matrixData}
      loading={loading}
      searching={searching}
      searchResults={searchResults}
      availableRoles={COMPANY_ROLES}
      onSearch={handleSearch}
      onAssign={handleAssign}
      onRevoke={handleRevoke}
    />
  );
}
